import Component from '../../js/_Component';
import Modal from '../../js/util/_Modal';

// Fill this with paths that can appear at the beginning of pages you want the popup to run on.
const WHITELISTED_PAGES = [
	'/xxxxxxxx/', // Always leave at least one otherwise it'll match everything.
	'/boats/',
	'/virtual-experience',
];

const WHITELIST_REGEX = new RegExp(`^(?:${WHITELISTED_PAGES.join('|')})`);

const MAX_DURATION = 30;

export default class BlockPopup extends Component {

	private originalParent: HTMLElement;

	constructor(element: HTMLElement) {
		super(element);

		this.originalParent = this.element.parentElement;

		if (!window.location.pathname.match(WHITELIST_REGEX)) {
			return;
		}


		this.startTimer();
	}

	startTimer() {
		let time = parseInt(window.sessionStorage.getItem('demoPopup')) | 0;
		if ((time > -1) && (time < MAX_DURATION)) {
			let interval = setInterval(() => {
				time += 1;
				if (time > MAX_DURATION) {
					clearInterval(interval);
					this.showPopup();
				} else {
					window.sessionStorage.setItem('demoPopup', `${time}`);
				}
			}, 1000);
		}
	}

	showPopup() {
		// If a modal already exists, don't display more.
		if (document.querySelector('.modal')) {
			return false;
		}
		
		window.sessionStorage.setItem('demoPopup', `-1`); // -1 prevents the popup from happening again.
		
		let modal = new Modal(this.element, 'no-border');
		modal.showPanel(0);
		this.element.classList.add('m-show');

		let closeButton = this.element.querySelector('.c-block-popup--button-holder .c-button.m-closepopup');
		let closeAction = () => modal.close();

		closeButton.addEventListener('click', closeAction);

		modal.onClose = () => {
			closeButton.removeEventListener('click', closeAction);
			this.element.classList.remove('m-show');
			this.originalParent.appendChild(this.element);
		};
	}

	restartTimer() {
		window.sessionStorage.removeItem('demoPopup');
		this.startTimer();
	}
}

Component.register(BlockPopup, 'BlockPopup');
